<div class="stepper">
  <!-- Step List -->
  <div class="stepper--step-list">
    <div
      *ngFor="let step of steps; let i = index"
      class="stepper--step"
      [class.active]="isStepActive(i)"
      [class.completed]="isStepCompleted(i)"
      [class.clickable]="isStepClickable(i)"
      (click)="onStepClick(i)"
    >
      <!-- Step Circle -->
      <div class="stepper--step-circle">
        <svg 
          *ngIf="isStepCompleted(i)" 
          class="stepper--check-icon" 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none"
        >
          <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span *ngIf="!isStepCompleted(i)" class="stepper--step-number">{{ i + 1 }}</span>
      </div>
      
      <!-- Step Label (Inline) -->
      <span class="stepper--step-label">{{ step.label }}</span>
      
      <!-- Connector Line -->
      <div
        *ngIf="i < steps.length - 1"
        class="stepper--connector"
        [class.completed]="isStepCompleted(i + 1) || isStepActive(i + 1)"
      ></div>
    </div>
  </div>

  <!-- Content Container (Panels + Navigation) -->
  <div class="stepper--content-container">
    <!-- Step Panels -->
    <div class="stepper--panels">
      <div
        *ngFor="let step of steps; let i = index"
        class="stepper--panel"
        [class.active]="isStepActive(i)"
      >
        <ng-container *ngIf="isStepActive(i)">
          <ng-container *ngIf="step.content">
            <ng-container *ngTemplateOutlet="step.content"></ng-container>
          </ng-container>
          <div *ngIf="!step.content" class="stepper--panel-content">
            Content for {{ step.label }}
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Navigation Buttons -->
    <div class="stepper--navigation" [class.stepper--navigation-floating]="floatingNavigation">
      <button
        *ngIf="canGoPrevious() && !hidePreviousButton"
        class="stepper--btn stepper--btn-previous"
        (click)="goToPrevious()"
        type="button"
      >
        ← Previous
      </button>
      <ng-container
        *ngIf="actionsTemplate"
        [ngTemplateOutlet]="actionsTemplate"
      ></ng-container>
      <button
        *ngIf="canGoNext() && !hideNextButton"
        class="stepper--btn stepper--btn-next"
        [disabled]="disableNextButton"
        (click)="goToNext()"
        type="button"
      >
        {{ currentNextButtonLabel }}
      </button>
      <button
        *ngIf="!canGoNext() && internalCurrentStep === steps.length - 1 && !hidePublishButton"
        class="stepper--btn stepper--btn-submit"
        [disabled]="disablePublishButton"
        (click)="next.emit()"
        type="button"
      >
        Publish
      </button>
    </div>
  </div>
</div>

